var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusLoadingRoute == false),expression:"statusLoadingRoute == false"}],ref:"targetElement",staticClass:"bg-gray-100 lg:mt-12"},[_c('downloadPDF')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }